<script>
export default {
  props: {
    title:    { type: String, default: '' },
    subtitle: { type: String, default: '' },
  },
}
</script>

<template>
  <section class="card-shell">
    <div v-if="title || subtitle" class="card-shell__header">
      <h2 v-if="title" class="section-title">{{ title }}</h2>
      <p v-if="subtitle" class="section-subtitle">{{ subtitle }}</p>
    </div>
    <div class="card-shell__body">
      <slot />
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import "~@/design/tokens";

.card-shell__header,
.card-shell__body {
  @media (max-width: calc(#{$bp-md} - 1px)) {
    padding-left: $space-5;
    padding-right: $space-5;
  }
}
</style>
